import { useEffect, useState } from "react";
import { Container, Row } from "reactstrap";
import Helmet from "../components/Helmet/Helmet";
import CommonSection from "../components/UI/CommonSection";
import CarItem from "../components/UI/CarItem";

const normalizeBodyStyle = (value) => {
  if (typeof value === "number") {
    switch (value) {
      case 1:
        return "Sedan";
      case 2:
        return "Hatchback";
      case 3:
        return "SUV";
      case 4:
        return "Break";
      case 5:
        return "Cabrio";
      case 6:
        return "Coupe";
      default:
        return "—";
    }
  }

  if (typeof value === "string") {
    return value.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
  }

  return "—";
};

const normalizeCarData = (carData) => {
  const make = carData.make || "";
  const model = carData.model || "";
  const title = carData.title || `${make} ${model}`.trim() || "Mașină disponibilă";

  const rawImages = carData.carImages ?? carData.images ?? carData.imagePaths ?? carData.image_paths ?? [];
  const images = (Array.isArray(rawImages) ? rawImages : [])
    .map((image) => (typeof image === "string" ? image : image?.imageUrl || image?.url || ""))
    .filter(Boolean);

  return {
    id: carData.id,
    make,
    model,
    title,
    year: carData.year || "—",
    fuel: carData.fuel || "—",
    body: normalizeBodyStyle(carData.body || carData.bodyStyle || ""),
    transmission: carData.transmission || "—",
    engine: carData.engine || "—",
    price: carData.price || 0,
    mileage: carData.mileage || carData.km || 0,
    images,
    description: carData.description || "",
  };
};

const CarListing = () => {
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchDataFromBackend = async () => {
      setLoading(true);
      setError("");

      try {
        const response = await fetch('https://automatrulatebackend-246f1b5aea0c.herokuapp.com/api/cars'); // Fetch all cars

        if (!response.ok) {
          throw new Error("Nu s-au putut încărca mașinile.");
        }

        const responseCars = await response.json();
        const normalizedCars = Array.isArray(responseCars)
          ? responseCars.map(normalizeCarData)
          : [];

        setCars(normalizedCars);
      } catch (err) {
        console.error("Error fetching car data:", err);
        setError(err.message || "A apărut o eroare la încărcarea mașinilor.");
      } finally {
        setLoading(false);
      }
    };

    fetchDataFromBackend();
  }, []);

  return (
    <Helmet title="Masini">
      <CommonSection title="Masini disponibile" />

      <section className="cars-listing-section">
        <Container>
          <div className="cars-listing-intro">
            <h3>Explorează oferta noastră</h3>
            <p>Descoperă mașinile disponibile, compară caracteristicile și găsește vehiculul potrivit.</p>
          </div>

          {loading && <div className="cars-listing-status">Se încarcă mașinile...</div>}

          {error && !loading && <div className="cars-listing-status error">{error}</div>}

          {!loading && !error && cars.length === 0 && (
            <div className="cars-listing-status">Momentan nu există mașini disponibile.</div>
          )}

          <Row className="g-4">
            {cars.map((item) => (
              <CarItem item={item} key={item.id} />
            ))}
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default CarListing;
